var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.options),function(val,key){return _c('SfCheckbox',{key:_vm.uuid + key,attrs:{"title":val,"value":key,"checked":_vm.selected.includes(key)},on:{"check":_vm.addItem,"uncheck":_vm.removeItem}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }